var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.PointLayer = new Class({
    Extends: OCS.Viewer.Classes.VectorLayer,
    debug: false,
    class_name: "PointLayer",
    options: {
        location: 4, //0 upperleft, 1 uppercenter, 2 upperright, 3 middleleft, 4 centered, 5 middleright, 6 lowerleft, 7 lowercenter, 8 lowerright 
        style_type: 'point'
    }

});

